import consts from "@/consts.js";
import Request from './request';

async function fetchOne(id) {// 获取单个
    return Request('get', "api/alliance-businesses/" + id);
}

async function fetchAll(data) {
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/alliance-businesses", data);
}

async function fetchAllForSelect(data) {
    data.fieldFilter = ["id", "alliance_business_code", "alliance_business_name",]; //仅筛选少许必要字段
    return Request('get', "api/alliance-businesses/select", data, false, false, true);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/alliance-businesses/edit?id=" + id, data);
    } else {
        return Request('post', "api/alliance-businesses/add" , data);
    }
}

export default {
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    save
};